import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './Tree.module.scss';

import Tree from './Tree';
import Spinner from 'Flow2/components/UI/Spinner/Spinner';
import FlexRow from 'Flow2/components/UI/Container/FlexRow'
import FlexCol from 'Flow2/components/UI/Container/FlexColumn'

import { injectIntl } from 'react-intl';
import * as actions from 'store/actions/index';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare, faMinusSquare, faFolderOpen, faFolder, faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';

import * as HF from 'Flow2/util/helperFunctions';

export const getSelectedIds = (list = {}, selected = []) => {
    //console.log(selected);
    const ids = selected.filter(id => {
        if (list.hasOwnProperty(id.replace("-", ""))) return true;
        return false;
    });
    return ids;
}

export const getSelectedKeywords = (list = {}, ids = []) => {
    const keywords = ids.map(id => {
        return list[id].name;
    });
    return keywords;
}

export const getSelectedElements = (list = {}, ids = []) => {
    const keywords = ids.map(id => {
        return list[id];
    });
    return keywords;
}

class TagTree extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            selected: props.selected || [],
            keywords: props.keywords || [],
            elements: props.elements || [],
            tree: [],
            list: {}
        }
    }

    static init = (props) => {
        const tree = props.tree;
        const list = HF.getListFromTree(tree, "id", "children");
        const selected = getSelectedIds(list, props.selected);
        const keywords = getSelectedKeywords(list, selected);
        const elements = getSelectedElements(list, selected);

        //console.log(list);
        
        const state = { tree, list, selected, keywords, elements };

        props.onLoaded(selected, keywords, elements);

        //console.log(state);
        return state;
    }

    onAdd = (data) => {
        let selected = [...this.state.selected];
        let keywords = [...this.state.keywords];
        let elements = [...this.state.elements];
        
        if(this.props.singleSelect) {
            selected = [ data.id ];
            keywords = [ data.name ];
            elements = [ data ];
        } else {
            if (selected.indexOf(data.id) === -1) {
                selected.push(data.id);
                keywords.push(data.name);
                elements.push(data);
            }
        }
        this.props.onSelect(selected, keywords, elements);
        this.setState({ selected: selected, keywords: keywords, elements: elements });
    }

    onRemove = (data) => {
        let selected = [...this.state.selected];
        let keywords = [...this.state.keywords];
        let elements = [...this.state.elements];
        
        // remove id from ids array
        let index = selected.indexOf(data.id);
        if (index !== -1) {
            selected.splice(index, 1);
            
            // remove keyword from keyword array
            index = keywords.indexOf(data.name);
            if (index !== -1) {
                keywords.splice(index, 1);
            }
            
            // remove element from elements array
            index = -1;
            for(let i = 0; i < elements.length; i++) {
                if(data.id === elements[i].id) {
                    index = i;
                }
            }
            if(index !== -1) {
                elements.splice(index, 1);
            }
            
            this.props.onSelect(selected, keywords, elements);
            this.setState({ selected: selected, keywords: keywords, elements: elements });
        }
    }

    isSelected = (data) => {
        return (this.state.selected.indexOf(data.id) === -1) ? classes.notSelected : classes.isSelected;
    }

    onClick = (data) => {
        if (this.state.selected.indexOf(data.id) === -1) {
            this.onAdd(data);
        } else {
            this.onRemove(data);
        }
    }

    render() {
        return (
            <Tree
                title={this.props.title || "Tags"}
                data={this.state.tree || []}
                selected={this.state.selected}
                onClick={this.onClick}
                onAdd={this.onAdd}
                onRemove={this.onRemove}
                isSelected={this.isSelected}
                loading={this.state.loading}
                singleSelect={this.props.singleSelect || false}
                extraContent={this.props.extraContent}
                filter={this.props.filter} />
        );
    }

    componentDidMount = () => {

    }

    static getDerivedStateFromProps(nextProps, prevState) {
        //console.log("getDerivedStateFromProps", nextProps.loading);
        if (!nextProps.loading && prevState.loading) {
            const state = TagTree.init(nextProps);
            return {
                loading: nextProps.loading,
                ...state
            }
        }
        return null;
    }
};



const mapStateToProps = (state) => {
    return {
        user: state.auth.user,
        group: state.admin.group,
        loading: false,//!state.admin.group.loaded,
        list: state.tags.treeList,
        tree: state.tags.tree
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(TagTree));
